import React from 'react';

/**
 * StudentInfoForm Component
 * Handles student first name and last name input for fundraiser orders
 * Extracted from Order.js for better maintainability and reusability
 */
const StudentInfoForm = ({ 
    studentInfo, 
    onStudentInfoChange, 
    teamPrimaryColor 
}) => {
    return (
        <div style={{
            backgroundColor: '#f8f9fa',
            padding: '2rem',
            borderRadius: '10px',
            marginBottom: '2rem'
        }}>
            <h2 style={{ color: teamPrimaryColor || '#0e456c' }}>
                Student Information
            </h2>
            <p>Please enter the name of the student you would like to support.</p>
            
            <div className="row g-3 pb-4">
                <div className="col-sm-6">
                    <label htmlFor="firstName" className="form-label">
                        Student First Name
                    </label>
                    <input 
                        type="text" 
                        className="form-control" 
                        id="firstName" 
                        placeholder="Student First Name"
                        value={studentInfo.firstName}
                        onChange={e => onStudentInfoChange(prev => ({ 
                            ...prev, 
                            firstName: e.target.value 
                        }))}
                        required
                    />
                    <div className="invalid-feedback">
                        Valid first name is required.
                    </div>
                </div>
                <div className="col-sm-6">
                    <label htmlFor="lastName" className="form-label">
                        Student Last Name
                    </label>
                    <input 
                        type="text" 
                        className="form-control" 
                        id="lastName" 
                        placeholder="Student Last Name" 
                        value={studentInfo.lastName}
                        onChange={e => onStudentInfoChange(prev => ({ 
                            ...prev, 
                            lastName: e.target.value 
                        }))}
                        required 
                    />
                    <div className="invalid-feedback">
                        Valid last name is required.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentInfoForm;
